/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { Provider as ItemManagersProvider } from '@jira/platform__services-item-managers/src/index.tsx';
import type { ClientOnlyNavigationContainersProps } from './types.tsx';

export const ClientOnlyNavigationContainers = ({
	children,
}: ClientOnlyNavigationContainersProps): React.JSX.Element | null => {
	if (!__SERVER__) {
		return <ItemManagersProvider>{children}</ItemManagersProvider>;
	}

	return null;
};
